<template>
  <div class="container">
    <AudioIcon />
    <h3 class="head">{{ headTitle }}</h3>
    <div class="content">
      <div class="member animate__animated animate__fadeIn delay-500ms">
        <img src="@game/assets/img/level05/girami.png" alt="" class="avatar">
        <div class="info">
          <div class="title">{{ girami }}</div>
          <div class="text">
            {{ giramiText1 }}
            <img src="@game/assets/img/level05/doc.png" alt="">
          </div>
        </div>
      </div>
      <div class="member animate__animated animate__fadeIn delay-1">
        <img src="@game/assets/img/level05/girami.png" alt="" class="avatar">
        <div class="info">
          <div class="title">{{ girami }}</div>
          <div class="text">
            {{ giramiText2 }}
            <img src="@game/assets/img/level05/doc.png" alt="">
          </div>
        </div>
      </div>
      <div class="member animate__animated animate__fadeIn delay-2">
        <img src="@game/assets/img/level05/girami.png" alt="" class="avatar">
        <div class="info">
          <div class="title">{{ girami }}</div>
          <div class="text">
            {{ giramiText3 }}
            <img src="@game/assets/img/level05/doc.png" alt="">
          </div>
        </div>
      </div>

      <div class="member animate__animated animate__fadeIn delay-3">
        <img src="@game/assets/img/level05/girami.png" alt="" class="avatar">
        <div class="info">
          <div class="title">{{ girami }}</div>
          <div class="text">{{ giramiText4 }}</div>
        </div>
      </div>
    </div>
    <div class="footer" @click="onForward">
      <img src="@game/assets/img/level05/reply-box.png" alt="">
    </div>
  </div>
</template>

<script>
import { tLevel5 } from '@game/utils';
import { audioMixinLevel5 } from '@game/mixins/audioMixin.js';

export default {
  name: 'Scene4',
  mixins: [audioMixinLevel5],
  data() {
    return {
      headTitle: tLevel5('headTitle'),
      girami: tLevel5('members.girami'),
      giramiText1: tLevel5('scene6.giramiText1'),
      giramiText2: tLevel5('scene6.giramiText2'),
      giramiText3: tLevel5('scene6.giramiText3'),
      giramiText4: tLevel5('scene6.giramiText4'),
    }
  },
  methods: {
    onForward() {
      this.$audioManager.playButtonNext(() => {
        this.$router.push({ name: 'L5Scene7' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  /* animation */
  position: absolute;

  width: 100%;
  height: 100%;
  background-image: url(@game/assets/img/level05/scene-4-bg.jpg);
  background-size: cover;
  ;
  background-repeat: no-repeat;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;


  .head {
    width: 100%;
    height: 60px;
    background-color: #8fcef5;
    border-radius: 20px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    color: #1d3082;
    font-weight: normal;
    margin: 0;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    box-sizing: border-box;
    width: 100%;
    padding: 30px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    gap: 30px;

    .member {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;

      img {
        margin-top: -5px;
        width: 50px;
      }

      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        align-self: flex-end;
        gap: 10px;

        .title {
          color: #aad8f7;
        }

        .text {
          box-sizing: border-box;
          background-color: #afdffb;
          color: #334b94;
          padding: 10px 20px;
          border-radius: 10px;
        }
      }
    }

    .member:nth-child(-n+3) .text {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;

      img {
        margin: 5px auto;
      }
    }
  }

  .footer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 100%;
    }

    &:hover {
      opacity: .8;
    }
  }
}
</style>